import './UserSupport.scss'

interface Props {
    phone: string;      // ex: '+4795129999' used as 'tel:+4795129999'
    phoneText: string;  // ex: '+47 951 29 999'
}

export const UserSupport = ({
	phone,
	phoneText,
}: Props): JSX.Element => (
	<div className="user-support">
		<div>NG brukerstøtte:</div>
		<div>
			<a href={`tel:${phone}`}>{phoneText}</a>
		</div>
	</div>
);


